module.exports = __webpack_public_path__ + "static/media/divyam.20113aae.png";